import { useEffect } from 'react';

import { getExperimentAssignment } from '@eventbrite/legacy-infra.statsig';

import { onStatsigReady } from '../../../../common/statsig';
import type { ListingPageProps } from '@/pages/listingPageTypes';

type UseExperimentAssignmentMismatchEffectArgs = {
  experiments: ListingPageProps['experiments'];
};

// This hook triggers client-side exposures for each experiment to ensure logs include enriched user metadata.
// SSR (Lambda@Edge) resolves the variant via loggingDisabled to avoid duplicate exposures and mitigate data gaps.
// Flow: L@E handles variant assignment for rendering; Client-side triggers the official exposure event with full metadata.
// See: EB-320651
export function useExperimentAssignmentMismatchEffect({ experiments }: UseExperimentAssignmentMismatchEffectArgs) {
  useEffect(() => {
    onStatsigReady(() => {
      if (!experiments) {
        return;
      }
      Object.entries(experiments).forEach(([experimentName, experimentData]) => {
        const clientSideExperimentAssignment = getExperimentAssignment(experimentName);
        if (clientSideExperimentAssignment?.getGroupName() !== experimentData.groupName) {
          console.error('[Statsig Error] Experiment Assignment Mismatch!', {
            experimentName,
            serverSideGroupName: experimentData.groupName,
            clientSideGroupName: clientSideExperimentAssignment?.getGroupName(),
          });
        }
      });
    });
  }, [experiments]);
}
